import { createModalContext, useModalState } from '@/common/app/modal'
import { ChildProps } from '@/common/util/props'

import ArticleDiagnosisModal from '@/components/container/modal/article/ArticleDiagnosisModal'

interface ArticleDiagnosisModalState {
  siteId: number
  articleProposalId: number
}

const defaultValue: ArticleDiagnosisModalState = { siteId: 0, articleProposalId: 0 }

export const ArticleDiagnosisModalContext =
  createModalContext<ArticleDiagnosisModalState>(defaultValue)

const ArticleDiagnosisModalProvider = ({ children }: ChildProps) => {
  const state = useModalState<ArticleDiagnosisModalState>(defaultValue)
  return (
    <ArticleDiagnosisModalContext.Provider value={state}>
      {children}
      <ArticleDiagnosisModal />
    </ArticleDiagnosisModalContext.Provider>
  )
}

export default ArticleDiagnosisModalProvider
